import {
  FulfilmentCentre,
  FulfilmentCentreRole,
} from '../../../redux-toolkits/fulfilment-centres/fulfilmentCentres.type'
import { EventTicketSettings } from '../../../redux-toolkits/events/events.type'

export const AROUND_LAGOS_LABEL = 'Around Lagos'

export const getVenueCentres = (centres: FulfilmentCentre[] = []) =>
  centres.filter(
    (centre) =>
      centre.role !== FulfilmentCentreRole.PARENT && centre.isActive !== false,
  )

export const getVenueCentreLabel = (
  venueCentreId: string | null | undefined,
  centres: FulfilmentCentre[],
) => {
  if (!venueCentreId) return AROUND_LAGOS_LABEL
  return (
    centres.find((centre) => centre._id === venueCentreId)?.name ??
    'Unavailable centre'
  )
}

export const applyVenueCentre = <T extends Partial<EventTicketSettings>>(
  settings: T,
  centre?: FulfilmentCentre,
): T =>
  centre
    ? {
        ...settings,
        venueCentre: centre._id,
        venue: centre.name,
        address: centre.address || settings.address,
      }
    : { ...settings, venueCentre: null }
